import { t } from 'i18next'
import { useCallback, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAlgorithmRunDetails, useWorkspaceDetails } from '../../../../hooks'
import {
  RiskReliefDeviationClassificationRunResult,
  RiskReliefNodeResult,
} from '../../../../store/reducers/workspaceReducer'
import { routePaths } from '../../../RootPage'
import RiskReliefSmartFunctionHeader from '../../components/RiskReliefSmartFunctionHeader'
import RiskReliefCell from '../../components/RiskReliefCell'

const RiskReliefDeviationClassificationSmartFunctionDetailsPageHeader = () => {
  const navigate = useNavigate()
  const { workspaceId, algorithmRunId, deviationId } = useParams()
  const { selectedWorkspace } = useWorkspaceDetails({
    workspaceId,
    preventFetch: true,
  })
  const { selectedAlgorithmRun } = useAlgorithmRunDetails({
    algorithmRunId,
    workspaceId,
  })

  const backButtonUrl = useMemo(
    () =>
      `${routePaths.WORKSPACE_DETAILS}/${selectedWorkspace?.id}/deviations/smartFunction/${deviationId}`,
    [selectedWorkspace?.id, deviationId]
  )

  const deviationClassificationGlobal = useMemo(
    () =>
      (selectedAlgorithmRun?.nodeResults as RiskReliefNodeResult)
        ?.DEVIATION_CLASSIFICATION
        ? (
            (selectedAlgorithmRun?.nodeResults as RiskReliefNodeResult)
              ?.DEVIATION_CLASSIFICATION as RiskReliefDeviationClassificationRunResult
          ).deviationClassificationGlobal
        : undefined,
    [selectedAlgorithmRun]
  )

  const onRunChange = useCallback(
    (algorithmRunId?: string) => {
      const url = `${routePaths.WORKSPACE_SMART_FUNCTION_DETAILS_RISK_REL_DEVIATION_CLASSIFICATION}/${workspaceId}/${algorithmRunId}/${deviationId}`
      navigate(url)
    },
    [navigate, workspaceId, deviationId]
  )

  return (
    <RiskReliefSmartFunctionHeader
      title={t(
        'workspaceDetailsPage.riskReliefSmartFunction.deviationClassification'
      )}
      backButtonUrl={backButtonUrl}
      onRunChange={onRunChange}
    >
      <RiskReliefCell
        title={t(
          'smartFunctionDetailsPage.riskReliefClassificationDeviation.header.occurrenceTitle'
        )}
        deviationValue={deviationClassificationGlobal?.occurrence}
        cellType="deviation"
      />
      <RiskReliefCell
        title={t(
          'smartFunctionDetailsPage.riskReliefClassificationDeviation.header.severityTitle'
        )}
        deviationValue={deviationClassificationGlobal?.severity}
        cellType="severity"
      />
      <RiskReliefCell
        title={t(
          'smartFunctionDetailsPage.riskReliefClassificationDeviation.header.detectabilityTitle'
        )}
        deviationValue={deviationClassificationGlobal?.detectability}
        cellType="deviation"
      />
      <RiskReliefCell
        title={t(
          'smartFunctionDetailsPage.riskReliefClassificationDeviation.header.riskTitle'
        )}
        risk={deviationClassificationGlobal?.risk}
        cellType="risk"
      />
    </RiskReliefSmartFunctionHeader>
  )
}

export default RiskReliefDeviationClassificationSmartFunctionDetailsPageHeader
